docReady(function () {
	document.querySelectorAll('.block-accordion').forEach(accordion => {
		const accordionTabs = Array.from(accordion.querySelectorAll('.block-accordion-item'))
			.map(accordionTab => {
				return {
					accordionTab,
					trigger: accordionTab.querySelector('.block-accordion-item__title'),
					content: accordionTab.querySelector('.block-accordion-item__content'),
				};
			})
			.filter(({ trigger, content }) => trigger && content);

		const setAccordionState = function(accordionTab, trigger, content, isOpen) {
			accordionTab.classList.toggle('active', isOpen);
			trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
			content.hidden = !isOpen;
		};

		accordionTabs.forEach(({ accordionTab, trigger, content }, index) => {
			if (trigger.dataset.accordionInitialised === 'true') {
				return;
			}

			trigger.dataset.accordionInitialised = 'true';
			setAccordionState(accordionTab, trigger, content, index === 0);

			trigger.addEventListener('click', function(e) {
				e.preventDefault();
				const shouldOpenClickedTab = !accordionTab.classList.contains('active');

				accordionTabs.forEach(({ accordionTab: tab, trigger: tabTrigger, content: tabContent }) => {
					setAccordionState(tab, tabTrigger, tabContent, tab === accordionTab && shouldOpenClickedTab);
				});
			});
		});
		
	});
})

docReady(function () {
    // Ajax test call 
    // $.ajax({
    //     type: "POST",
    //     url: example_call.ajaxurl,
    //     data: ({ 
    //         action: "example_call", 
    //     }),
    //     success: function(response) {
    //         console.log(response)
    //     },
    // });
    
});

docReady(function () {
	const anchorNavs = document.querySelectorAll('.anchor-nav');

	anchorNavs.forEach(function (anchorNav) {
		const links = Array.from(anchorNav.querySelectorAll('.anchor-nav__link[href^="#"]'));
		let items = [];
		let ticking = false;

		const getTarget = function (link) {
			const hash = link.getAttribute('href');

			// Only in-page hash links can be tracked against page sections.
			if (!hash || hash === '#') {
				return null;
			}

			try {
				return document.getElementById(decodeURIComponent(hash.slice(1)));
			} catch (_error) {
				return null;
			}
		};

		const refreshItems = function () {
			items = links.map(function (link) {
				return {
					link,
					target: getTarget(link),
				};
			}).filter(function (item) {
				return item.target;
			}).sort(function (a, b) {
				return a.target.getBoundingClientRect().top - b.target.getBoundingClientRect().top;
			});
		};

		const setActiveLink = function (activeLink) {
			links.forEach(function (link) {
				const isActive = link === activeLink;

				// Keep styling and accessibility state in sync.
				link.classList.toggle('is-active', isActive);

				if (isActive) {
					link.setAttribute('aria-current', 'location');
				} else {
					link.removeAttribute('aria-current');
				}
			});
		};

		const updateActiveLink = function () {
			ticking = false;

			if (!items.length) {
				return;
			}

			// Treat a section as active once its top crosses the upper third-ish
			// of the viewport, rather than waiting for it to hit the very top.
			const activationY = window.innerHeight * 0.35;
			let activeItem = items[0];

			items.forEach(function (item) {
				if (item.target.getBoundingClientRect().top <= activationY) {
					activeItem = item;
				}
			});

			setActiveLink(activeItem.link);
		};

		const queueUpdate = function () {
			if (ticking) {
				return;
			}

			// Batch scroll work into animation frames.
			ticking = true;
			requestAnimationFrame(updateActiveLink);
		};

		links.forEach(function (link) {
			link.addEventListener('click', function () {
				setActiveLink(link);
			});
		});

		refreshItems();
		updateActiveLink();

		window.addEventListener('scroll', queueUpdate, { passive: true });
		window.addEventListener('resize', function () {
			refreshItems();
			queueUpdate();
		});
	});
});

docReady(function () {
	const sliders = document.querySelectorAll('.block-case-studies__slider');

	sliders.forEach(function (slider) {
		const block = slider.closest('.block-case-studies');

		if (!block) {
			return;
		}

		const collapseGutter = function () {
			if (slider.scrollLeft <= 0) {
				return;
			}

			block.classList.add('is-scrolled');
			slider.removeEventListener('scroll', collapseGutter);
		};

		slider.addEventListener('scroll', collapseGutter, { passive: true });
	});
});

window.CaptchaCallback = function () {
	const config = window.contactForm || {};
	const captcha = window.grecaptcha && (window.grecaptcha.enterprise || window.grecaptcha);
	const siteKey = config.recaptchaSiteKey || '6LdaM1gtAAAAAP5IhiNMGC1P_AXgL31NdLo_9C3t';
	const action = config.recaptchaAction || 'CONTACT';

	if (!captcha || !siteKey) {
		return;
	}

	document.querySelectorAll('.g-recaptcha').forEach((element) => {
		if (element.dataset.widgetid) {
			return;
		}

		const widgetId = captcha.render(element, {
			sitekey: siteKey,
			action,
		});

		element.dataset.widgetid = widgetId;
	});

	document.dispatchEvent(new Event('themeRecaptchaReady'));
};

docReady(function () {
	const forms = document.querySelectorAll('[data-contact-form]');

	if (!forms.length) {
		return;
	}

	let recaptchaScriptPromise = null;

	const isRecaptchaEnabled = () => {
		const config = window.contactForm || {};

		return config.recaptchaEnabled !== false;
	};

	const loadRecaptchaScript = () => {
		if (!isRecaptchaEnabled()) {
			return Promise.resolve();
		}

		if (window.grecaptcha && (window.grecaptcha.enterprise || window.grecaptcha)) {
			window.CaptchaCallback();
			return Promise.resolve();
		}

		if (recaptchaScriptPromise) {
			return recaptchaScriptPromise;
		}

		recaptchaScriptPromise = new Promise((resolve, reject) => {
			const existingScript = document.getElementById('theme-google-recaptcha');

			document.addEventListener('themeRecaptchaReady', resolve, { once: true });

			if (existingScript) {
				return;
			}

			const config = window.contactForm || {};
			const script = document.createElement('script');

			script.id = 'theme-google-recaptcha';
			script.src = config.recaptchaScriptUrl || 'https://www.google.com/recaptcha/enterprise.js?onload=CaptchaCallback&render=explicit';
			script.async = true;
			script.defer = true;
			script.onerror = () => {
				recaptchaScriptPromise = null;
				reject(new Error('There was a problem loading reCAPTCHA. Please try again.'));
			};

			document.head.appendChild(script);
		});

		return recaptchaScriptPromise;
	};

	forms.forEach((form) => {
		const typeInputs = form.querySelectorAll('input[name="project_type"]');
		const budgetGroup = form.querySelector('[data-contact-budget-group]');
		const budgetTitle = form.querySelector('[data-contact-budget-title]');
		const budgetInputs = form.querySelectorAll('[data-contact-budget-input]');
		const budgetLabels = form.querySelectorAll('[data-contact-budget-label]');
		const submitButton = form.querySelector('.block-contact-form__submit');
		const submitText = form.querySelector('.block-contact-form__submit-text');
		const statusMessage = form.querySelector('[data-contact-form-status]');
		const recaptcha = form.querySelector('[data-contact-recaptcha]');
		const successMessage = 'Thank you for your request, we will get in touch soon.';

		if (!typeInputs.length || !budgetGroup || !budgetTitle || !budgetInputs.length || !budgetLabels.length) {
			return;
		}

		const budgetOptions = {
			'New website': {
				title: 'What is your project budget?',
				options: ['< £15k', '£15-40k', '£40-60k', '£60k+'],
			},
			'Website takeover': {
				title: 'What is your monthly budget?',
				options: ['<£500', '£500-£1k', '£1k-£3k', '£4k+'],
			},
		};

		const updateBudgetGroup = (selectedType) => {
			const config = budgetOptions[selectedType];

			if (!config) {
				budgetGroup.hidden = true;
				budgetInputs.forEach((input) => {
					input.checked = false;
					input.disabled = true;
				});
				return;
			}

			budgetGroup.hidden = false;
			budgetTitle.textContent = config.title;

			budgetInputs.forEach((input, index) => {
				const option = config.options[index];
				const label = budgetLabels[index];

				input.disabled = false;
				input.value = option;
				input.checked = index === 0;
				label.textContent = option;
			});
		};

		const getContactFormConfig = () => window.contactForm || {};

		const getAjaxUrl = () => {
			const config = getContactFormConfig();

			if (config.ajaxUrl) {
				return config.ajaxUrl;
			}

			return '/wp-admin/admin-ajax.php';
		};

		const getResponseMessage = (response, fallback) => {
			if (!response) {
				return fallback;
			}

			if (typeof response.data === 'string') {
				return response.data;
			}

			if (response.data && typeof response.data.message === 'string') {
				return response.data.message;
			}

			if (typeof response.message === 'string') {
				return response.message;
			}

			return fallback;
		};

		const setStatus = (message, type) => {
			if (!statusMessage) {
				return;
			}

			statusMessage.hidden = message === '';
			statusMessage.textContent = message;
			statusMessage.classList.toggle('is-error', type === 'error');
			statusMessage.classList.toggle('is-success', type === 'success');
			statusMessage.setAttribute('role', type === 'error' ? 'alert' : 'status');
		};

		const setSubmitting = (isSubmitting) => {
			if (submitButton) {
				submitButton.disabled = isSubmitting;
				submitButton.classList.toggle('is-submitting', isSubmitting);
			}

			if (submitText) {
				submitText.textContent = isSubmitting ? 'SENDING' : 'SEND';
			}
		};

		const setSuccessState = () => {
			form.classList.add('is-success');

			window.setTimeout(() => {
				form.classList.add('is-success-complete');
			}, 250);
		};

		const clearSuccessState = () => {
			form.classList.remove('is-success', 'is-success-complete');
		};

		const trackContactConversion = () => {
			const config = getContactFormConfig();

			const eventData = {
				send_to: config.conversionId || 'AW-11091017397/d7qaCO_UoqIaELX9zagp',
			};

			if (typeof window.gtag !== 'function') {
				if (!Array.isArray(window.dataLayer)) {
					return;
				}

				window.gtag = function () {
					window.dataLayer.push(arguments);
				};
			}

			// Advanced Consent Mode allows the event to fire; Google's tag uses the
			// current consent state to decide between cookieless and full measurement.
			window.gtag('event', 'conversion', eventData);
		};

		const getRecaptchaToken = () => {
			if (!isRecaptchaEnabled()) {
				return '';
			}

			const captcha = window.grecaptcha && (window.grecaptcha.enterprise || window.grecaptcha);

			if (!recaptcha || !captcha || !recaptcha.dataset.widgetid) {
				return '';
			}

			return captcha.getResponse(recaptcha.dataset.widgetid);
		};

		const resetRecaptcha = () => {
			if (!isRecaptchaEnabled()) {
				return;
			}

			const captcha = window.grecaptcha && (window.grecaptcha.enterprise || window.grecaptcha);

			if (!recaptcha || !captcha || !recaptcha.dataset.widgetid) {
				return;
			}

			captcha.reset(recaptcha.dataset.widgetid);
		};

		const prepareRecaptcha = () => {
			if (!isRecaptchaEnabled()) {
				return Promise.resolve();
			}

			if (!recaptcha || recaptcha.dataset.widgetid) {
				return Promise.resolve();
			}

			return loadRecaptchaScript().catch((error) => {
				setStatus(error.message || 'There was a problem loading reCAPTCHA. Please try again.', 'error');
			});
		};

		typeInputs.forEach((input) => {
			input.addEventListener('change', function () {
				if (this.checked) {
					updateBudgetGroup(this.value);
				}
			});
		});

		const checkedType = form.querySelector('input[name="project_type"]:checked');
		updateBudgetGroup(checkedType ? checkedType.value : null);

		if (recaptcha && isRecaptchaEnabled()) {
			if ('IntersectionObserver' in window) {
				const recaptchaObserver = new IntersectionObserver((entries) => {
					if (!entries.some((entry) => entry.isIntersecting)) {
						return;
					}

					recaptchaObserver.disconnect();
					prepareRecaptcha();
				}, {
					rootMargin: '600px 0px',
				});

				recaptchaObserver.observe(form);
			}

			['focusin', 'pointerenter', 'touchstart'].forEach((eventName) => {
				form.addEventListener(eventName, prepareRecaptcha, { once: true, passive: true });
			});
		}

		form.addEventListener('submit', async function (e) {
			e.preventDefault();

			if (!form.checkValidity()) {
				form.reportValidity();
				return;
			}

			await prepareRecaptcha();

			const formData = new FormData(form);
			const config = getContactFormConfig();
			const recaptchaToken = getRecaptchaToken();

			if (recaptcha && isRecaptchaEnabled() && !recaptchaToken) {
				setStatus('Please complete the reCAPTCHA before sending your message.', 'error');
				clearSuccessState();
				return;
			}

			formData.append('action', 'contact_form');
			formData.set('g-recaptcha-response', recaptchaToken);

			if (config.nonce) {
				formData.append('nonce', config.nonce);
			}

			setStatus('', '');
			clearSuccessState();
			setSubmitting(true);

			fetch(getAjaxUrl(), {
				method: 'POST',
				body: formData,
				credentials: 'same-origin',
			})
				.then((response) => {
					if (!response.ok) {
						throw new Error('There was a problem sending your message. Please try again.');
					}

					return response.json().catch(() => {
						throw new Error('There was a problem sending your message. Please try again.');
					});
				})
				.then((response) => {
					if (response && response.success === false) {
						throw new Error(getResponseMessage(response, 'There was a problem sending your message. Please try again.'));
					}

					form.reset();
					resetRecaptcha();

					const resetType = form.querySelector('input[name="project_type"]:checked');
					updateBudgetGroup(resetType ? resetType.value : null);
					setStatus(successMessage, 'success');
					setSubmitting(false);
					setSuccessState();
					trackContactConversion();

					if (submitButton) {
						submitButton.disabled = true;
					}
				})
				.catch((error) => {
					resetRecaptcha();
					clearSuccessState();
					setStatus(error.message || 'There was a problem sending your message. Please try again.', 'error');
					setSubmitting(false);
				});
		});
	});
});

(function () {
	const CONSENT_COOKIE = 'shape_works_cookie_consent';
	const COOKIE_MAX_AGE = 60 * 60 * 24 * 180;
	const CATEGORIES = ['analytics', 'advertising'];

	// Create this early so contactForm.js and Google Consent Mode can read
	// consent before the footer UI has initialised.
	const consentApi = window.ShapeWorksCookieConsent = window.ShapeWorksCookieConsent || {};

	// Treat missing or malformed values as denied. Consent has to be explicit.
	const normalizePreferences = (preferences) => {
		const normalized = {
			analytics: false,
			advertising: false,
		};

		if (!preferences || typeof preferences !== 'object') {
			return normalized;
		}

		CATEGORIES.forEach((category) => {
			normalized[category] = preferences[category] === true;
		});

		return normalized;
	};

	const setConsentApiState = (preferences, options = {}) => {
		const normalized = normalizePreferences(preferences);

		consentApi.preferences = normalized;
		consentApi.hasStoredConsent = options.stored === true || consentApi.hasStoredConsent === true;
		consentApi.hasConsent = function (category) {
			return consentApi.preferences && consentApi.preferences[category] === true;
		};

		return normalized;
	};

	const getCookieValue = (name) => {
		const escapedName = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
		const match = document.cookie.match(new RegExp('(?:^|; )' + escapedName + '=([^;]*)'));

		return match ? match[1] : '';
	};

	// Store only the user's category choices in a first-party necessary cookie.
	const readPreferences = () => {
		const value = getCookieValue(CONSENT_COOKIE);

		if (!value) {
			return null;
		}

		try {
			return normalizePreferences(JSON.parse(decodeURIComponent(value)));
		} catch (error) {
			return null;
		}
	};

	const writePreferences = (preferences) => {
		const payload = encodeURIComponent(JSON.stringify({
			version: 1,
			analytics: preferences.analytics,
			advertising: preferences.advertising,
			updatedAt: new Date().toISOString(),
		}));
		const secure = window.location.protocol === 'https:' ? '; Secure' : '';

		document.cookie = `${CONSENT_COOKIE}=${payload}; Max-Age=${COOKIE_MAX_AGE}; Path=/; SameSite=Lax${secure}`;
	};

	// Google may set cookies on the apex domain as well as the current host, so
	// removal needs to try each plausible domain/path combination.
	const getDomainCandidates = () => {
		const hostname = window.location.hostname;
		const parts = hostname.split('.');
		const domains = ['', hostname];

		if (parts.length > 1) {
			for (let index = 0; index < parts.length - 1; index += 1) {
				domains.push('.' + parts.slice(index).join('.'));
			}
		}

		return Array.from(new Set(domains));
	};

	const deleteCookie = (name) => {
		const secure = window.location.protocol === 'https:' ? '; Secure' : '';
		const paths = ['/', window.location.pathname || '/'];

		getDomainCandidates().forEach((domain) => {
			paths.forEach((path) => {
				document.cookie = `${name}=; Max-Age=0; Path=${path}; SameSite=Lax${secure}${domain ? `; Domain=${domain}` : ''}`;
			});
		});
	};

	// Best-effort cleanup when consent is withdrawn. Browser and third-party
	// cookie restrictions can prevent deleting every Google-set cookie.
	const deleteGoogleCookies = (preferences) => {
		if (preferences.analytics && preferences.advertising) {
			return;
		}

		document.cookie.split(';').forEach((cookie) => {
			const name = cookie.split('=')[0].trim();

			if (!preferences.analytics && (/^_ga/.test(name) || name === '_gid' || /^_gat/.test(name))) {
				deleteCookie(name);
			}

			if (!preferences.advertising && (/^_gcl/.test(name) || name === 'IDE' || name === 'test_cookie')) {
				deleteCookie(name);
			}
		});
	};

	// Keep the site's simple categories mapped to Google's Consent Mode names.
	const getGoogleConsent = (preferences) => ({
		analytics_storage: preferences.analytics ? 'granted' : 'denied',
		ad_storage: preferences.advertising ? 'granted' : 'denied',
		ad_user_data: preferences.advertising ? 'granted' : 'denied',
		ad_personalization: preferences.advertising ? 'granted' : 'denied',
		functionality_storage: 'granted',
		security_storage: 'granted',
	});

	// Apply preferences to our shared API, update Google, and clean up old
	// cookies if consent has been withdrawn.
	const applyPreferences = (preferences, options = {}) => {
		const normalized = setConsentApiState(preferences, options);

		if (typeof window.gtag === 'function') {
			window.gtag('consent', options.initial ? 'default' : 'update', getGoogleConsent(normalized));
		}

		deleteGoogleCookies(normalized);
	};

	const storedPreferences = readPreferences();

	// Rehydrate saved consent before wiring up the UI so returning visitors do not
	// see the banner again and Google starts with their previous choices.
	if (storedPreferences) {
		applyPreferences(storedPreferences, {
			initial: true,
			stored: true,
		});
	} else {
		setConsentApiState(null);
	}

	// Public save method used by the banner, the preferences dialog, and any
	// future component that needs to update consent.
	consentApi.save = function (preferences) {
		const normalized = normalizePreferences(preferences);

		writePreferences(normalized);
		applyPreferences(normalized, {
			stored: true,
		});

		document.dispatchEvent(new CustomEvent('shapeWorksCookieConsentChanged', {
			detail: normalized,
		}));
	};

	docReady(function () {
		const banner = document.querySelector('[data-cookie-banner]');
		const panel = document.querySelector('[data-cookie-panel]');
		const openButtons = document.querySelectorAll('[data-cookie-open]');
		const acceptButtons = document.querySelectorAll('[data-cookie-accept]');
		const rejectButtons = document.querySelectorAll('[data-cookie-reject]');
		const customizeButtons = document.querySelectorAll('[data-cookie-customize]');
		const saveButtons = document.querySelectorAll('[data-cookie-save]');
		const closeButtons = document.querySelectorAll('[data-cookie-close]');
		const categoryInputs = document.querySelectorAll('[data-cookie-category]');
		let previousFocus = null;

		if (!banner || !panel) {
			return;
		}

		// Keep the dialog controls in sync with the stored state whenever it opens.
		const syncInputs = () => {
			const preferences = normalizePreferences(consentApi.preferences);

			categoryInputs.forEach((input) => {
				input.checked = preferences[input.value] === true;
			});
		};

		const getInputPreferences = () => {
			const preferences = normalizePreferences();

			categoryInputs.forEach((input) => {
				preferences[input.value] = input.checked === true;
			});

			return preferences;
		};

		// If the user closes the custom panel on their first visit, return them to
		// the banner so they still make an explicit choice.
		const closePanel = () => {
			panel.hidden = true;

			if (!consentApi.hasStoredConsent) {
				banner.hidden = false;
			}

			if (previousFocus && typeof previousFocus.focus === 'function') {
				previousFocus.focus();
			}
		};

		// Remember focus so keyboard users are returned to the control they used.
		const openPanel = () => {
			previousFocus = document.activeElement;
			syncInputs();
			banner.hidden = true;
			panel.hidden = false;

			const firstInput = panel.querySelector('input:not([disabled]), button, a[href]');

			if (firstInput) {
				firstInput.focus();
			}
		};

		const saveAndClose = (preferences) => {
			consentApi.save(preferences);
			banner.hidden = true;
			closePanel();
		};

		// No stored consent means this is the visitor's first decision point.
		if (!consentApi.hasStoredConsent) {
			banner.hidden = false;
		}

		syncInputs();

		acceptButtons.forEach((button) => {
			button.addEventListener('click', () => {
				saveAndClose({
					analytics: true,
					advertising: true,
				});
			});
		});

		rejectButtons.forEach((button) => {
			button.addEventListener('click', () => {
				saveAndClose({
					analytics: false,
					advertising: false,
				});
			});
		});

		customizeButtons.forEach((button) => {
			button.addEventListener('click', openPanel);
		});

		openButtons.forEach((button) => {
			button.addEventListener('click', (event) => {
				event.preventDefault();
				openPanel();
			});
		});

		saveButtons.forEach((button) => {
			button.addEventListener('click', () => {
				saveAndClose(getInputPreferences());
			});
		});

		closeButtons.forEach((button) => {
			button.addEventListener('click', closePanel);
		});

		// Basic dialog keyboard support: Escape closes and Tab stays inside.
		panel.addEventListener('keydown', (event) => {
			if (event.key === 'Escape') {
				closePanel();
				return;
			}

			if (event.key !== 'Tab') {
				return;
			}

			const focusableElements = Array.from(panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'))
				.filter((element) => element.offsetParent !== null);

			if (!focusableElements.length) {
				return;
			}

			const firstElement = focusableElements[0];
			const lastElement = focusableElements[focusableElements.length - 1];

			if (event.shiftKey && document.activeElement === firstElement) {
				event.preventDefault();
				lastElement.focus();
			} else if (!event.shiftKey && document.activeElement === lastElement) {
				event.preventDefault();
				firstElement.focus();
			}
		});
	});
})();

docReady(function () {
	// Native CSS cursors are painted by the browser, outside the page DOM.
	// This real DOM element lets the SVG use mix-blend-mode against page content.
	const hasFinePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
	const moveEvent = window.PointerEvent ? 'pointermove' : 'mousemove';
	const downEvent = window.PointerEvent ? 'pointerdown' : 'mousedown';
	const upEvent = window.PointerEvent ? 'pointerup' : 'mouseup';
	const clickableSelector = 'a, button, label, summary, [role="button"], input[type="button"], input[type="reset"], input[type="submit"]';

	// Touch/coarse-pointer devices keep the normal cursor behavior.
	if (!hasFinePointer || !document.body) {
		return;
	}

	const cursor = document.createElement('span');
	let isVisible = false;
	let rafId = null;
	let cursorX = 0;
	let cursorY = 0;

	cursor.className = 'custom-cursor';
	cursor.setAttribute('aria-hidden', 'true');
	document.body.appendChild(cursor);

	// Pointer events can fire very quickly, so we batch DOM writes to animation frames.
	const setPosition = function () {
		cursor.style.setProperty('--cursor-x', `${cursorX}px`);
		cursor.style.setProperty('--cursor-y', `${cursorY}px`);
		rafId = null;
	};

	const queuePosition = function () {
		if (rafId === null) {
			rafId = window.requestAnimationFrame(setPosition);
		}
	};

	// Keep the cursor hidden until the first pointer position is known.
	const showCursor = function () {
		if (!isVisible) {
			cursor.classList.add('is-visible');
			isVisible = true;
		}
	};

	const hideCursor = function () {
		cursor.classList.remove('is-visible', 'is-active', 'is-hovering-clickable');
		isVisible = false;
	};

	// Move the DOM cursor to the browser pointer position.
	document.addEventListener(moveEvent, function (e) {
		if (e.pointerType === 'touch') {
			return;
		}

		cursorX = e.clientX;
		cursorY = e.clientY;
		cursor.classList.toggle('is-hovering-clickable', Boolean(e.target.closest?.(clickableSelector)));
		showCursor();
		queuePosition();
	}, { passive: true });

	// A small press state keeps clicks from feeling detached from the custom cursor.
	document.addEventListener(downEvent, function (e) {
		if (e.pointerType !== 'touch') {
			cursor.classList.add('is-active');
		}
	}, { passive: true });

	document.addEventListener(upEvent, function () {
		cursor.classList.remove('is-active');
	}, { passive: true });

	if (window.PointerEvent) {
		document.addEventListener('pointercancel', hideCursor, { passive: true });
	}

	document.documentElement.addEventListener('mouseleave', hideCursor);
	window.addEventListener('blur', hideCursor);
});

function docReady(fn) {//IE9+
    // see if DOM is already available
    if (document.readyState === "complete" || document.readyState === "interactive") {
        // call on next available tick
        setTimeout(fn, 1);
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}
(function () {
	window.dataLayer = window.dataLayer || [];

	window.gtag = window.gtag || function () {
		window.dataLayer.push(arguments);
	};

	const consentApi = window.ShapeWorksCookieConsent || {};
	const hasConsent = function (category) {
		if (typeof consentApi.hasConsent === 'function') {
			return consentApi.hasConsent(category);
		}

		return consentApi.preferences && consentApi.preferences[category] === true;
	};

	// Advanced Consent Mode: Google tags load immediately, but optional storage
	// starts denied unless the visitor has already granted it.
	window.gtag('consent', 'default', {
		analytics_storage: hasConsent('analytics') ? 'granted' : 'denied',
		ad_storage: hasConsent('advertising') ? 'granted' : 'denied',
		ad_user_data: hasConsent('advertising') ? 'granted' : 'denied',
		ad_personalization: hasConsent('advertising') ? 'granted' : 'denied',
		functionality_storage: 'granted',
		security_storage: 'granted',
		wait_for_update: 500,
	});

	window.gtag('js', new Date());
	// In advanced mode the tag still fires; denied consent makes Google send
	// cookieless measurements rather than writing optional cookies.
	window.gtag('config', 'G-N8GT8YV25K');
	window.gtag('config', 'AW-11091017397');
})();

docReady(function () {

	const header = document.querySelector('.header');
	const menuToggle = document.querySelector('.header__menu-toggle');
	const menu = document.getElementById('site-menu');
	const desktopHoverQuery = window.matchMedia('(min-width: 768px) and (hover: hover) and (pointer: fine)');
	const scrollGap = 24;

	const isDesktopHoverNav = function() {
		return desktopHoverQuery.matches;
	};

	const setMenuOpen = function(isOpen, openMethod = '') {
		if (!header || !menuToggle) {
			return;
		}

		header.classList.toggle('is-menu-open', isOpen && openMethod !== 'hover');
		header.classList.toggle('is-menu-hover-open', isOpen && openMethod === 'hover');
		menuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
		document.documentElement.classList.toggle('has-site-menu-open', isOpen);
	};

	const getHeaderOffset = function() {
		if (!header) {
			return scrollGap;
		}

		return Math.ceil(Math.max(header.getBoundingClientRect().bottom, 0) + scrollGap);
	};

	const getSamePageHash = function(link) {
		const href = link.getAttribute('href');

		if (!href || href === '#') {
			return '';
		}

		const url = new URL(href, window.location.href);

		if (
			url.origin !== window.location.origin ||
			url.pathname.replace(/\/$/, '') !== window.location.pathname.replace(/\/$/, '') ||
			url.search !== window.location.search
		) {
			return '';
		}

		return url.hash;
	};

	const scrollToHash = function(hash, updateHash) {
		const targetId = decodeURIComponent(hash.substring(1));
		const target = document.getElementById(targetId);

		if (!target) {
			return false;
		}

		const targetTop = target.getBoundingClientRect().top + window.pageYOffset;
		const scrollTop = Math.max(targetTop - getHeaderOffset(), 0);

		window.scrollTo({
			top: window.pageYOffset,
			left: window.pageXOffset,
			behavior: 'auto'
		});

		window.scrollTo({
			top: scrollTop,
			behavior: 'smooth'
		});

		if (updateHash) {
			history.pushState(null, '', hash);
		}

		return true;
	};

	document.addEventListener('click', function(e) {
		const link = e.target.closest('a[href*="#"]');

		if (!link) {
			return;
		}

		const hash = getSamePageHash(link);

		if (!hash) {
			return;
		}

		e.preventDefault();
		setMenuOpen(false);
		requestAnimationFrame(function() {
			scrollToHash(hash, false);
		});
	});

	if (menuToggle && menu) {
		menuToggle.addEventListener('click', function(e) {
			e.stopPropagation();

			if (isDesktopHoverNav()) {
				return;
			}

			setMenuOpen(!header.classList.contains('is-menu-open'));
		});

		menuToggle.addEventListener('mouseenter', function() {
			if (isDesktopHoverNav()) {
				setMenuOpen(true, 'hover');
			}
		});

		menu.addEventListener('mouseenter', function() {
			if (isDesktopHoverNav()) {
				setMenuOpen(true, 'hover');
			}
		});

		header.addEventListener('mouseleave', function() {
			if (isDesktopHoverNav()) {
				setMenuOpen(false);
			}
		});

		header.addEventListener('focusin', function(e) {
			if (
				isDesktopHoverNav() &&
				(e.target.closest('.header__menu-toggle') || e.target.closest('.header__nav'))
			) {
				setMenuOpen(true, 'hover');
			}
		});

		header.addEventListener('focusout', function() {
			if (!isDesktopHoverNav()) {
				return;
			}

			requestAnimationFrame(function() {
				if (!header.contains(document.activeElement)) {
					setMenuOpen(false);
				}
			});
		});

		menu.addEventListener('click', function(e) {
			if (e.target.closest('a')) {
				setMenuOpen(false);
			}

			if (e.target === menu) {
				setMenuOpen(false);
			}
		});

		document.addEventListener('click', function(e) {
			if (!header.classList.contains('is-menu-open')) {
				return;
			}

			if (e.target.closest('.header__nav') || e.target.closest('.header__menu-toggle')) {
				return;
			}

			setMenuOpen(false);
		});

		document.addEventListener('keydown', function(e) {
			if (e.key === 'Escape') {
				setMenuOpen(false);
			}
		});

		desktopHoverQuery.addEventListener('change', function() {
			setMenuOpen(false);
		});
	}

	if (window.location.hash) {
		setTimeout(function() {
			scrollToHash(window.location.hash, false);
		}, 1);
	}

});

docReady(function () {
	const marquees = document.querySelectorAll('.tick-marquee');

	if (!marquees.length) {
		return;
	}

	const updateMarquee = function (marquee) {
		const group = marquee.querySelector('.tick-marquee__group');

		if (!group) {
			return;
		}

		// Measure one repeated group. After moving exactly this far, the next
		// identical group is in the same position, making the loop seamless.
		const distance = group.getBoundingClientRect().width;
		const speed = parseFloat(getComputedStyle(marquee).getPropertyValue('--marquee-pixels-per-second')) || 30;

		if (!distance || !speed) {
			return;
		}

		// Keep the visible speed constant:
		// duration = pixels to travel / pixels per second.
		marquee.style.setProperty('--marquee-scroll-distance', `-${distance}px`);
		marquee.style.setProperty('--marquee-duration', `${distance / speed}s`);
	};

	const updateAllMarquees = function () {
		marquees.forEach(updateMarquee);
	};

	const queueUpdate = function () {
		requestAnimationFrame(updateAllMarquees);
	};

	updateAllMarquees();

	if ('ResizeObserver' in window) {
		// Recalculate when responsive text sizing or content width changes.
		const resizeObserver = new ResizeObserver(function (entries) {
			entries.forEach(function (entry) {
				const marquee = entry.target.closest('.tick-marquee');

				if (marquee) {
					updateMarquee(marquee);
				}
			});
		});

		marquees.forEach(function (marquee) {
			const group = marquee.querySelector('.tick-marquee__group');

			if (group) {
				resizeObserver.observe(group);
			}
		});
	} else {
		window.addEventListener('resize', queueUpdate);
	}

	if (document.fonts && document.fonts.ready) {
		document.fonts.ready.then(updateAllMarquees);
	}
});
